export default __webpack_public_path__ + "static/media/news-medium.597cb0c8.jpg";